export function formatDate(ts) {
  if (!ts) return "-";
  const date = ts?.toDate ? ts.toDate() : new Date(ts);
  return date.toLocaleDateString();
}

export function formatDateTime(ts) {
  if (!ts) return "-";
  const date = ts?.toDate ? ts.toDate() : new Date(ts);
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}

export function bytesToSize(bytes = 0) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function downloadCsv(fileName, rows) {
  const csv = rows
    .map((row) =>
      row
        .map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`)
        .join(",")
    )
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
